module.exports = __webpack_public_path__ + "static/media/square-pink.38357b62.svg";